import { render } from "./BoardList.vue?vue&type=template&id=7aa2e7ee&scoped=true"
import script from "./BoardList.vue?vue&type=script&lang=js"
export * from "./BoardList.vue?vue&type=script&lang=js"

import "./BoardList.vue?vue&type=style&index=0&id=7aa2e7ee&scoped=true&lang=scss"
import "./BoardList.vue?vue&type=style&index=1&id=7aa2e7ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa2e7ee"]])

export default __exports__